import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Hub from './Hub';
import ConsumerPortal from './consumer-portal/ConsumerPortal';
import AgentPortal from './agent-portal/AgentPortal';

function Translations() {
  return (
    <Routes>
      <Route exact path="/" element={<Hub />} />
      <Route path="/consumer" element={<ConsumerPortal />} />
      <Route path="/agent" element={<AgentPortal />} />
    </Routes>
  );
}

export default Translations;
